// https://www.npmjs.com/package/lightgallery
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';

/**
 * Initialize simple global lightbox
 */
const lightboxes = document.getElementsByClassName('js-single-lightbox');
if (lightboxes) {
  for (const el of lightboxes) {
    lightGallery(el, {
      selector: 'this',
      plugins: [lgVideo],
      download: false,
      mobileSettings: {
        controls: false,
        showCloseIcon: true,
        download: false,
      },
    });
  }
}

/**
 * Project Testimonials Lightboxes
 */
const projectGalleryLightboxes = document.getElementsByClassName(
  'js-project-gallery-lightboxes',
);
if (projectGalleryLightboxes) {
  for (const el of projectGalleryLightboxes) {
    lightGallery(el, {
      selector: '.js-project-gallery-lightboxes-link',
      plugins: [lgThumbnail, lgVideo],
      download: false,
      thumbnail: true,
      mobileSettings: {
        controls: false,
        showCloseIcon: true,
        download: false,
      },
    });
  }
}

/**
 * Project Testimonials Lightboxes
 */
const projectTestimonialslLightboxes = document.getElementsByClassName(
  'js-project-testimonials-gallery',
);
if (projectTestimonialslLightboxes) {
  for (const el of projectTestimonialslLightboxes) {
    lightGallery(el, {
      selector: 'a',
      plugins: [lgThumbnail],
      download: false,
      thumbnail: true,
      mobileSettings: {
        controls: false,
        showCloseIcon: true,
        download: false,
      },
    });
  }
}
